import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareBehindSquare2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSquareBehindSquare2"><Path fillRule="evenodd" clipRule="evenodd" d="M22 2H8V8H2V22H16V16H22V2ZM16 14H20V4H10V8H16V14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareBehindSquare2;
